import { Permission } from '@dispatch/shared/types';
import { Checkbox } from '@mui/material';
import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { UserForm } from '../details/UserDetails';

interface ControlledCheckBoxProps {
  userPermissions: Record<string, Permission>;
  disabledPermissions: Record<string, Permission>;
  setUserPermissions: React.Dispatch<
    React.SetStateAction<Record<string, Permission>>
  >;
  setDisabledPermissions: React.Dispatch<
    React.SetStateAction<Record<string, Permission>>
  >;
  setValue: UseFormSetValue<UserForm>;
  disabledIds: string[];
  permission: Permission;
}

export const UserPermissionCheckBox = ({
  userPermissions,
  disabledPermissions,
  setUserPermissions,
  setDisabledPermissions,
  setValue,
  disabledIds,
  permission,
}: ControlledCheckBoxProps) => {
  const [checked, setChecked] = React.useState(true);

  React.useEffect(() => {
    if (disabledIds.includes(permission?.id)) {
      setChecked(false);
    }
  }, [disabledIds, permission?.id]);

  return (
    <Checkbox
      onChange={(e) => {
        const { value, checked: currentValue } = e.target;
        const currentPermissions = userPermissions;
        const currentDisabledPermissions = disabledPermissions;
        const keyVal = value.split('.');
        const key: string = keyVal?.[0];
        setChecked(currentValue);
        if (currentValue) {
          currentPermissions[key] = permission;
          delete currentDisabledPermissions[key];

          setUserPermissions(currentPermissions);
          setDisabledPermissions(currentDisabledPermissions);
        } else {
          delete currentPermissions[key];
          currentDisabledPermissions[key] = permission;
          setUserPermissions(currentPermissions);
          setDisabledPermissions(currentDisabledPermissions);
        }

        const allowed: string[] = Object.entries(currentPermissions).flatMap(
          (task: [string, Permission]) => (task[1]?.id ? task[1]?.id : [])
        );
        const disabled: string[] = Object.entries(
          currentDisabledPermissions
        ).flatMap((task: [string, Permission]) =>
          task[1]?.id ? task[1]?.id : []
        );

        setValue('permissions', allowed, { shouldDirty: true });
        setValue('disabledPermissions', disabled, { shouldDirty: true });
      }}
      value={`${permission?.operationId}.${permission?.id}`}
      checked={checked}
    />
  );
};
